import React, { useState, useRef,  useEffect } from 'react';
import AnalityicsScript from './assest/analityics-script';

import MiddleSection from './components/MiddleSection';
import Results from './components/results';
import './App.css';
import getToken from './common/gettoken';
import { fetchDataFromAPI } from './common/fetchDataFromAPI'; 
import setDefaultUserMesType from './common/mesType';
import convertFormdataByType from './common/convertMesType'; 
import LoginForm from './components/LoginForm';
import LogBanner from './components/LogBanner';
import AdvancedTab from './components/advancedTab';
import ToggleMes from './components/ToggleMes';

import './components/logBanner.css';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [logMessage, setLogMessage] = useState('');
  const [logColor, setLogColor] = useState('red'); 
  const [stateData, setStateData] = useState('');
  const hasPageRendered = useRef({effect1: false, effect2: false, effect3: false});
  const [selectedMesTypeButton, setSelectedMesTypeButton] = useState(setDefaultUserMesType);
  const [advancedUser, setAdvancedUser] = useState(false);
  const [userId, setUserId] = useState("")

  
  const [formData, setFormData] = useState({
    calculationMode: 'cpu',
    // CPU fields
    Tcase: selectedMesTypeButton === "SI" ? 80 : 176,
    CPU_Power: 270,
    Num_CPU: 100,
    CPUType: 'SP5',
    // GPU Server fields
    serverType: '',
    serverSubModel: '',
    numServers: 1,
    // Shared fields
    HruType: 'HRU_WATER_3',
    MeasurementSystem: selectedMesTypeButton,
  });


  const [avancedFormData, setAvancedFormData] = useState({
    totalPower: 0,
    saturationTemperature: 0,
    condenserSurfaceArea: 0,
    HTC: 1200,
    Vdot: 8,
    MeasurementSystem: selectedMesTypeButton,
  });


  const [plotData, setPlotData] = useState(null);



  useEffect(() => {
    // Create a URLSearchParams object from the current URL
    const urlParams = new URLSearchParams(window.location.search);

    // Get the value of the 'advanced' parameter
    const advancedParam = urlParams.get('advanced');

    // Set the advancedUser state based on the parameter value
    if (advancedParam === 'true') {
      setAdvancedUser(true);
    } else {
      setAdvancedUser(false);
    }
  }, []); // Empty dependency array to run only on mount



  useEffect(() => {


    const fetchData = async () => {
      const params = {
        Tcase: formData.Tcase,
        CPU_Power: formData.CPU_Power,
        Num_CPU: formData.Num_CPU,
        CPUType: formData.CPUType,
        HruType: formData.HruType,
        MeasurementSystem: formData.MeasurementSystem,
      };
      const token = JSON.parse(localStorage.getItem('zuta'));
      const url = 'calculateInletWater';
      const method = 'GET';

      const data = await fetchDataFromAPI(url, method, params, token);
      if (data && data.error) {
        if(data.error === 'invalid_token'){
          setIsAuthenticated(false);
          console.log("invalid_token");
        }
        if(data.error === 'Bad Request'){
            console.log("Bad Request");
        }
        console.log('Error: ', data);
      }else if(!data.error){
        setIsAuthenticated(true);
      }

    }


  fetchData();
// eslint-disable-next-line
  }, []); 
  

  const handleLogin = async (username) => {
    console.log(username);
    setUserId(username);
    let tryLogin = await getToken(username, username); // Get the token after authentication
    console.log(tryLogin);
    // const token = JSON.parse(localStorage.getItem('zuta'));
    if (tryLogin.access_token) {
        setIsAuthenticated(true);
    } else {
        console.log("Not authorized");
        setLogColor("red");
        setLogMessage("Not authorized");

    }
};

const [renderResults, setRenderResults] = useState(false);
const renderCount = useRef(0);



const handleMesTypeButtonClick = (type) => {
  setFormData((prevData) => ({ ...prevData,
    MeasurementSystem: type,
    Tcase: convertFormdataByType(type, prevData.Tcase)
  })); 


  setAvancedFormData((prevData) => ({ ...prevData,
    MeasurementSystem: type,
  })); 

  setSelectedMesTypeButton(type); // set mes type ACTIVE BUTTON 
  setDefaultUserMesType (type);  // set mes type on LOCAL STORAGE button using ref 
};



//tracking the formData state and update the result component
  useEffect(() => {
    if(hasPageRendered.current["effect2"]){

      setStateData(formData);

    }
    hasPageRendered.current["effect2"] = true;
  }, [formData]);

  const toggleAdvancedUser = () => {
    setAdvancedUser(prevState => !prevState);
    window.dispatchEvent(new Event("resize"));
  };



  console.log("isAuthenticated", isAuthenticated);
  if (!isAuthenticated) {
    return (
      <div>
        <LoginForm handleLogin={handleLogin} />
        <div>
          <LogBanner
            logMessage={logMessage}
            setLogMessage={setLogMessage}
            color={logColor}
          />
      </div>
    </div>
    );
  }

  return (
    <div id='windowCtr' className='container-fluid'>
      <AnalityicsScript userId={userId}/>
      <div id="toolbar">
        <button onClick={toggleAdvancedUser}>
          {advancedUser ? 'Hide Advanced Options' : 'Show Advanced Options'}
        </button>
      </div>

      <div>


        {advancedUser && <AdvancedTab
          advancedFormData={avancedFormData} 
          setAdvancedFormData={setAvancedFormData} 
          setPlotData={setPlotData}
          setIsAuthenticated={setIsAuthenticated}
          setLogColor={setLogColor}  
          setLogMessage={setLogMessage}
          measurementSystem={formData.MeasurementSystem}
          handleMesTypeButtonClick={handleMesTypeButtonClick}
          selectedMesTypeButton={selectedMesTypeButton}
        
        />}
      </div>

      <div id="mainCtr" className='row'>
        <MiddleSection
          formData={formData}
          setFormData={setFormData}
          setPlotData={setPlotData}
          setIsAuthenticated={setIsAuthenticated}
          setLogColor={setLogColor}  
          setLogMessage={setLogMessage}
          measurementSystem={formData.MeasurementSystem}
          advancedUser={advancedUser}

        />
          <Results
            plotData={plotData}
            stateData={stateData}
            advancedUser={advancedUser}
          />

      </div>
      <div>
        <LogBanner
          logMessage={logMessage}
          setLogMessage={setLogMessage}
          color={logColor}
        />
      </div>
      <ToggleMes
          handleMesTypeButtonClick={handleMesTypeButtonClick}
          selectedMesTypeButton={selectedMesTypeButton}
          measurementSystem={formData.MeasurementSystem}
      />
    </div>
  );
}

export default App;
